/** The logical pass containing the repeated form's re-entry beat. */
export function loopStartPassIndex(passStarts: readonly number[], loopStartBeat = 0): number {
  let index = 0;
  while (index + 1 < passStarts.length && passStarts[index + 1] <= loopStartBeat + 1e-6) {
    index += 1;
  }
  return index;
}

/**
 * The first traversal can include entry passes (the head); later traversals
 * repeat only the passes at and after the loop start (the solo choruses).
 * Keep the player's pass counter and the score playhead on the same map.
 */
export function loopingPassPosition(pass: number, passCount: number, firstLoopPass = 0) {
  const count = Math.max(1, passCount);
  const first = Math.max(0, Math.min(count - 1, firstLoopPass));
  const index = Math.max(0, Math.trunc(pass) - 1);
  if (index < count) return { cycleIndex: 0, passIndex: index };
  const repeated = count - first;
  return {
    cycleIndex: 1 + Math.floor((index - count) / repeated),
    passIndex: first + ((index - count) % repeated),
  };
}
